(function () {
'use strict';

var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	};

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

	}

})(jQuery);

var documentInit$1 = documentInit;

var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();
			console.log(this);

		}
		init() {
			this.$trigger = $(selectors.trigger, this.$container);
			this.$links = $('a', this.$container).not(this.$trigger);
		}

		bind() {
			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

	}

})(jQuery);


var mobileNavInit$1 = mobileNavInit;

var formInit;

(function ($) {

	const selectors = {
		form: 'form',
		datepicker: '[data-toggle="datepicker"]',
	};

	formInit = function () {
		$(selectors.form).each((i, el) => {
			new Form(el);
		});
	};

	class Form {
		constructor(element) {
			this.$form = $(element);

			this.init();

		}
		init() {

			const self = this;

			this.$select = $('select', this.$form);
			this.$required = $('[required]', this.$form);
			this.type = $('[name="typ"]', this.$form).val();
			this.$hoursSelect = $('[name="voucher_time"]', this.$form);

			this.availableWeekdays = [];
			this.bookedDates = false;

			if (this.type == 'uczen') {
				this.availableWeekdays = wp_params.form_options.available_days_uczen.weekdays;
			}
			else if (this.type == 'online' || this.type == 'niezaleznie') {
				this.availableWeekdays = wp_params.form_options.available_days_klient.weekdays;
				this.bookedDates = wp_params.form_options.available_days_klient.booked_dates;
			}

			this.enabledDates = wp_params.form_options.enabled_dates || [];
			this.disabledDates = wp_params.form_options.disabled_dates || [];
			this.endDate = wp_params.form_options.calendar_end_date || false;

			var datepickerArgs = {
				language: 'pl-PL',
				format: 'yyyy-mm-dd',
				startDate: Date.now(),
				autoHide: true,
				filter: (date, view) => {
					if (view !== 'day') return true;

					const formattedDate = self.$datePicker.datepicker('formatDate', date);

					if (self.enabledDates && self.enabledDates.length) {

						var dateEnabled = false;

						$.each(self.enabledDates, (i, date) => {
							date = date.trim();
							if (date == formattedDate) dateEnabled = true;
						});

						if (dateEnabled) return true;

					}

					if (self.disabledDates && self.disabledDates.length) {

						var dateDisabled = false;

						$.each(self.disabledDates, (i, date) => {
							date = date.trim();
							if (date == formattedDate) dateDisabled = true;
						});

						if (dateDisabled) return false;

					}

					if (self.availableWeekdays) {
						var day_in_options = false;
						var dayFullyBooked = false;

						$.each(self.availableWeekdays, (day, hours) => {
							if (date.getDay() === parseInt(day)) day_in_options = true;
						});

						if (!day_in_options) return false;

						if (self.bookedDates && self.bookedDates[formattedDate]) {
							if (Object.values(self.bookedDates[formattedDate]).every(item => item == 0)) {
								dayFullyBooked = true;
							}
						}
						if (dayFullyBooked) return false;
					}

					return true;

				}
			};

			if (this.endDate) {
				datepickerArgs.endDate = this.endDate;
			}

			this.$datePicker = $(selectors.datepicker, this.$form).datepicker(datepickerArgs);

			this.bind();

			this.$select.trigger('change');

		}

		bind() {

			const self = this;

			this.validate = this.validate.bind(this);
			this.onDatePicked = this.onDatePicked.bind(this);

			this.$select.on('change', function () { self.onSelectChange($(this)); });
			this.$select.on('focus', function () { self.onSelectFocus($(this)); });
			this.$form.on('submit', this.validate);

			this.$datePicker.on('pick.datepicker', self.onDatePicked);

		}

		onSelectChange($select) {

			if ($select.find(':selected').attr('data-placeholder') !== undefined) {
				$select.addClass('is-placeholder');
			}
			else {
				$select.removeClass('is-placeholder');
			}
		}

		onSelectFocus($select) {
			$select.removeClass('is-placeholder');
		}

		validate() {

			const self = this;

			$('[type="submit"]', self.$form).addClass('is-loading');

			var valid = true;

			this.$required.each((i, el) => {
				var val = '';
				if ($(el).is('select')) {
					val = $(el).find(':selected').val();
				}
				else {
					val = $(el).val();
				}


				if (!val) {
					valid = false;
					$(el).addClass('is-invalid');

					$('[type="submit"]', self.$form).removeClass('is-loading');
				}
			});

			return valid;

		}

		onDatePicked(e) {
			const self = this;
			const pickedDate = e.date;
			var pickedDay = pickedDate.getDay();

			//fake day to saturday if not in options
			if (this.availableWeekdays[pickedDay] === undefined) pickedDay = 6;

			const formattedDate = self.$datePicker.datepicker('formatDate', pickedDate);

			this.$hoursSelect.find('option:not([data-placeholder])').remove();

			const hours = this.availableWeekdays[pickedDay];

			if (hours) {
				$.each(hours, (i, hour) => {

					if (self.bookedDates && self.bookedDates[formattedDate] && !self.bookedDates[formattedDate][hour.godziny] > 0) {
						return;
					}

					self.$hoursSelect.append('<option value="' + hour.godziny + '">' + hour.godziny + '</option > ');
				});

				this.$hoursSelect.prop('disabled', false);
			}
			else {
				this.$hoursSelect.prop('disabled', true);
			}

		}

	}

})(jQuery);


var formInit$1 = formInit;

var codeVerifierInit;

(function ($) {

	const selectors = {
		btn: '[data-verify-code]',
		input: '[data-code-input]',
		result: '[data-validate-result]',
		id: '[data-validate-id]',
		name: '[data-validate-name]',
		error: '[data-validate-error]',
		ok: '[data-validate-ok]'
	};

	codeVerifierInit = function () {
		$(selectors.btn).each((i, el) => {
			new CodeVerifier(el);
		});
	};

	class CodeVerifier {
		constructor(element) {
			this.$btn = $(element);

			this.init();

		}
		init() {

			this.$form = this.$btn.closest('form');
			this.$input = $(selectors.input, this.$form);
			this.$result = $(selectors.result, this.$form);
			this.$id_input = $(selectors.id, this.$form);
			this.$name_input = $(selectors.name, this.$form);
			this.$err = $(selectors.error, this.$form);
			this.$ok = $(selectors.ok, this.$form);

			this.bind();

		}

		bind() {
			this.verify = this.verify.bind(this);

			this.$btn.on('click', this.verify);

		}

		verify() {

			const self = this;

			if (self.$btn.hasClass('is-loading') || self.$form.hasClass('is-loading')) return;

			var data = {
				code: this.$input.val()
			};

			$.ajax({
				type: "POST",
				url: wp_params.ajax_url,
				data: {
					'action': 'verify_code',
					'args': data
				},
				beforeSend: _ => {

					this.$result.val('');

					self.$input.removeClass('is-valid is-invalid');
					self.$btn.addClass('is-loading');
					self.$input.addClass('is-loading');

					self.$err.hide();
					self.$ok.hide();
				},
				success: response => {
					if (response && response.success) {
						self.$result.val('1');
						self.$input.addClass('is-valid');
						self.$ok.show();
						if (response.voucher_id) {
							self.$id_input.val(response.voucher_id);
						}
						if (response.product) {
							self.$name_input.val(response.product);
						}
					}
					else {
						self.$input.addClass('is-invalid');
						self.$err.show();

					}
				},
				complete: _ => {
					self.$btn.removeClass('is-loading');
					self.$input.removeClass('is-loading');
				}
			});
		}

	}

})(jQuery);


var codeVerifierInit$1 = codeVerifierInit;

(function ($) {

	$(document).ready(function () {

		documentInit$1();
		mobileNavInit$1();
		formInit$1();
		codeVerifierInit$1();

	});

})(jQuery);

}());
